import Headroom from "headroom.js";

export default function Forms() {

  let fields = Array.prototype.slice.call(document.querySelectorAll('input,select,textarea'), 0);

  let focusHandler = (e) => {
    e.target.classList.add('user-focused'); 

    let form = e.target.closest('form')

    if (form) {
      form.classList.add('user-focused') 
    }
  }

  fields.forEach((field) => {
    field.addEventListener('input', focusHandler)
    field.addEventListener('change', focusHandler)
    field.addEventListener('focus', focusHandler)
  })
}
